import { render, staticRenderFns } from "./callForBidDetailList.vue?vue&type=template&id=1bad7096&scoped=true"
import script from "./callForBidDetailList.vue?vue&type=script&lang=js"
export * from "./callForBidDetailList.vue?vue&type=script&lang=js"
import style0 from "./callForBidDetailList.vue?vue&type=style&index=0&id=1bad7096&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bad7096",
  null
  
)

export default component.exports